type AccessIssue = any;
export type { AccessIssue as default };

export const AccessIssues = [0, 1];
